// Purchase and payable reviews for the year-end workflow.
window.PlummeI18n.register('no', {
  'route.arsavslutning-kjop': 'Kjøp og bilag',
  'clo.purchases.title': 'Kjøp og bilag',
  'clo.purchases.year': 'Inntektsår {{year}}',
  'clo.purchases.subtitle': 'Følg opp kjøp og bilag for inntektsåret {{year}}.',
  'clo.purchases.pending': '{{count}} kjøp eller bilag må behandles før kjøpskontrollen for {{year}} er klar.',
  'clo.purchases.ready': 'Ingen ubehandlede kjøp eller manglende kjøpsbilag funnet for {{year}}.',
  'clo.purchases.unsupported': 'Kjøpskontrollen er ikke støttet for dette landet, regelverket eller året.',
  'clo.purchases.purchaseIssues': 'Kjøp som må følges opp',
  'clo.purchases.missingTitle': 'Transaksjoner som mangler bilag ({{count}})',
  'clo.purchases.missingSummary': 'Legg til dokumentasjonen som hører til hver transaksjon.',
  'clo.purchases.reviewMissing': 'Vis og legg til bilag',
  'clo.purchases.documentsModalTitle': 'Manglende bilag',
  'clo.purchases.missingHelp': 'Dra et bilag til riktig linje, eller last det opp.',
  'clo.purchases.missingDateAction': 'Mangler gyldig dato – åpne transaksjonen for å velge år',
  'clo.purchases.upload': 'Last opp bilag',
  'clo.purchases.uploading': 'Laster opp …',
  'clo.purchases.uploaded': 'Bilaget er lagt til.',
  'clo.purchases.uploadLater': 'Laster opp senere',
  'clo.purchases.deferredHelp': 'Bilag lastes opp senere. Du kan fortsette gjennomgangen, men bilagene må legges til før året avsluttes.',
  'clo.purchases.uploadError': 'Kunne ikke laste opp bilaget.',
  'clo.purchases.noMissingDocumentation': 'Alle transaksjonene har bilag.',
  'clo.purchases.inboxSideHelp': 'Her ligger bilagene som ikke er bokført ennå.',
  'clo.purchases.inboxInteractionHint': 'Åpne et bilag for å kontrollere det.',
  'clo.purchases.continueWithoutInbox': 'Fortsett uten behandling',
  'clo.purchases.continueConfirmTitle': 'Ikke relevant for årsavslutningen?',
  'clo.purchases.continueConfirmText': 'Bekreft at de {{count}} ubehandlede bilagene ikke er relevante for kjøpskontrollen i {{year}}. De blir liggende i innboksen, men blokkerer ikke denne årsavslutningen.',
  'clo.purchases.inboxExcluded': 'Bilagene er vurdert som ikke relevante for denne årsavslutningen.',
  'clo.purchases.excludeError': 'Kunne ikke lagre vurderingen.',
  'clo.purchases.noPurchaseIssues': 'Ingen åpne avvik på registrerte kjøp.',
  'clo.purchases.missingDocumentation': 'Mangler bilag',
  'clo.purchases.lostDocumentation': 'Bilag er meldt mistet. Avviket er loggført, men kjøpet trenger fortsatt dokumentasjon.',
  'clo.purchases.draft': 'Kjøpsutkast må ferdigbehandles',
  'clo.purchases.undated': 'Mangler gyldig dato. Avklar hvilket år posten tilhører.',
  'clo.purchases.unknownDate': 'Mangler gyldig dato',
  'clo.purchases.inboxTitle': 'Ubehandlede bilag ({{count}})',
  'clo.purchases.inboxScope': 'Behandle bilagene som tilhører {{year}}, eller fortsett hvis de ikke er relevante for denne årsavslutningen.',
  'clo.purchases.scopeHelp': 'En ubetalt leverandørfaktura kan være ferdig bokført. Betaling, MVA-avstemming og periodisering kontrolleres i egne steg. Klar her betyr at de registrerte kjøpene og innboksen har bestått denne kontrollen.',
  'clo.purchases.openPurchase': 'Åpne kjøpet',
  'clo.purchases.openInbox': 'Behandle bilag i innboksen',
  'clo.purchases.back': 'Tilbake til kjøpskontrollen',
  'clo.purchases.backToClosing': 'Tilbake til årsavslutning',
  'clo.purchases.loadError': 'Kunne ikke åpne kjøpsflaten.',
  'clo.payables.title': 'Leverandørgjeld',
  'clo.payables.itemsTitle': 'Åpne leverandørposter per 31.12.{{year}}',
  'clo.payables.itemsHelp': 'Leverandørfakturaer som stod åpne ved årsskiftet, også fra tidligere år. Senere betalinger vises separat og endrer ikke saldoen per 31.12.',
  'clo.payables.supplier': 'Leverandør og dokument',
  'clo.payables.date': 'Dokumentdato og forfall',
  'clo.payables.openAmount': 'Åpent ved årsskiftet',
  'clo.payables.followUp': 'Oppfølging',
  'clo.payables.paidAfterAmount': 'Betalt etter årsskiftet: {{amount}}',
  'clo.payables.balanceTitle': 'Avstemming mot hovedboken',
  'clo.payables.assessmentTitle': 'Vurdering og godkjenning',
  'clo.payables.reviewHelp': 'Vurder postene med avkryssing i tabellen før du godkjenner kontrollen.',
  'clo.payables.saveAssessment': 'Lagre vurdering',
  'clo.payables.help': 'Hovedbok og åpne leverandørposter per 31.12.{{year}} sammenlignes automatisk.',
  'clo.payables.ledger': 'Hovedbok',
  'clo.payables.subledger': 'Reskontro',
  'clo.payables.difference': 'Differanse',
  'clo.payables.needsReview': 'Må vurderes ({{count}})',
  'clo.payables.allOpen': 'Alle åpne poster ({{count}})',
  'clo.payables.due': 'Forfall {{date}}',
  'clo.payables.noDueDate': 'Ingen forfallsdato',
  'clo.payables.open': 'Åpne transaksjonen',
  'clo.payables.reviewed': 'Vurdert',
  'clo.payables.noRows': 'Ingen åpne poster i dette utvalget.',
  'clo.payables.cutOffQuestion': 'Finnes det varer eller tjenester mottatt før 31.12.{{year}} som ennå ikke er bokført?',
  'clo.payables.cutOffHelp': 'Dette er den delen Plumme ikke kan avgjøre ut fra bokførte data alene.',
  'clo.payables.cutOffNo': 'Nei, alt er bokført',
  'clo.payables.cutOffYes': 'Ja, noe mangler',
  'clo.payables.unrecordedHelp': 'Registrer de manglende kjøpene før kontrollen kan fullføres.',
  'clo.payables.complete': 'Godkjenn kontroll',
  'clo.payables.saved': 'Leverandørgjelden er kontrollert.',
  'clo.payables.saveError': 'Kunne ikke lagre kontrollen.',
  'clo.payables.reason.reconciled': 'Avstemt',
  'clo.payables.reason.notApplicable': 'Ingen leverandørgjeld ved årsslutt.',
  'clo.payables.reason.unsupported': 'Kontrollen støttes ikke for dette landet, regelverket eller året.',
  'clo.payables.reason.stale': 'Tallgrunnlaget er endret. Kontroller postene på nytt.',
  'clo.payables.reason.ledgerDifference': 'Hovedbok og reskontro stemmer ikke.',
  'clo.payables.reason.missingDocument': 'En åpen leverandørpost mangler bilag.',
  'clo.payables.reason.invalidDate': 'En leverandørfaktura mangler gyldig dato.',
  'clo.payables.reason.basisReviewRequired': 'Kontogrunnlaget må kontrolleres.',
  'clo.payables.reason.cutOffRequired': 'Én opplysning må avklares.',
  'clo.payables.reason.unrecordedItems': 'Manglende kjøp må bokføres.',
  'clo.payables.reason.exceptionsRequired': 'Vurder postene som er markert.',
  'clo.payables.reason.reviewRequired': 'Kontrollen må fullføres.',
  'clo.payables.issue.ledgerDifference': 'Differansen må rettes i bokføringen før kontrollen kan fullføres.',
  'clo.payables.issue.missingDocument': 'Legg til bilag på åpne poster som mangler dokumentasjon.',
  'clo.payables.issue.invalidDate': 'Åpne leverandørfakturaen og registrer riktig fakturadato.',
  'clo.payables.issue.basisReviewRequired': 'Plumme kan ikke beregne et sikkert kontogrunnlag for denne virksomheten.',
  'clo.payables.flag.old': 'Over 90 dager gammel',
  'clo.payables.flag.overdue': 'Forfalt over 30 dager',
  'clo.payables.flag.negative': 'Negativ saldo',
  'clo.payables.flag.duplicate': 'Mulig duplikat',
  'clo.payables.flag.currency': 'Valutapost',
  'clo.payables.flag.missingDocument': 'Mangler bilag',
  'clo.payables.flag.paidAfter': 'Betalt etter årsslutt',
});
